import React from "react";
import { i18n } from "~/i18n.js";

export function RenderLedgerAmount({ ledger, correctionfactor = 1 }) {
  return (
    <div style={{ marginRight: 6 }}>
      {!ledger.payment_status && (
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end", gap: 4 }}>
          {ledger.amount_calculated !== ledger.amount && (
            <span
              style={{
                textDecoration: "line-through",
                whiteSpace: "nowrap",
              }}
            >
              {i18n.parseLocaleCurrencyString(
                correctionfactor * ledger.amount_calculated
              )}
            </span>
          )}
          <span style={{ whiteSpace: "nowrap" }}>
            {i18n.parseLocaleCurrencyString(correctionfactor * ledger.amount)}
          </span>
        </div>
      )}
      {/* Pending value, show italic */}
      {ledger.payment_status && ledger.amount_calculated !== ledger.amount && (
        <span
          style={{ fontStyle: "italic", color: "gray", whiteSpace: "nowrap" }}
        >
          ...{" "}
          {i18n.parseLocaleCurrencyString(
            correctionfactor * ledger.amount_calculated
          )}
        </span>
      )}
      {/* Confirmed value, all ok */}
      {ledger.payment_status && ledger.amount_calculated === ledger.amount && (
        <span style={{ whiteSpace: "nowrap" }}>
          {i18n.parseLocaleCurrencyString(correctionfactor * ledger.amount)}
        </span>
      )}
    </div>
  );
}
